/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-09-22
 * @brief EHP 사용자 관리 개발
 *
 ********************************************************************/
import React from "react";
// recoil
import { useRecoilValue, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
/**
 * @brief EHP 사용자 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
//component
function NoUserView(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const curTree = props.curTree;
    const setParentIsMobile = props.setIsMobile;
    const setParentPopWin = props.setPopWin;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__right_content workplace__info workplace__main info__input newtype" },
            React.createElement("p", { className: "txt-ready" },
                React.createElement("span", null, "\uD68C\uC0AC\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694.")))));
}
;
export default NoUserView;
